import { render, staticRenderFns } from "./BlogSuburb.vue?vue&type=template&id=9bcd93e4&scoped=true&"
import script from "./BlogSuburb.vue?vue&type=script&lang=ts&"
export * from "./BlogSuburb.vue?vue&type=script&lang=ts&"
import style0 from "./BlogSuburb.vue?vue&type=style&index=0&id=9bcd93e4&scoped=true&lang=css&"
import style1 from "./BlogSuburb.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bcd93e4",
  null
  
)

export default component.exports